import "./App.css";
import { BrowserRouter as Router,Routes,  Route } from "react-router-dom";
import Header from "./Pages/Header/Header";
import Footer from "./Pages/Footer/Footer";
import Home from "./Pages/Home/Home/Home";
import Empty from "./Pages/Empty/Empty";





import About from "./Pages/Home/About/About";



import Products from "./Pages/Products/Products"
import { Contact } from "./Pages/Contact/Contact";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import Gallery from "./Pages/Gallerys/Gallery";
import { Career } from "./Pages/Career/Career";



function App() {
  return (
    <div className="App">

        <Router>
          <Header></Header>
          <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/contact" element={<Contact  />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/career" element={<Career />} />
          <Route path="*" element={<Empty />} />
        </Routes>
        <a
      href="https://wa.me/7447454145?text=Hello! I'm interested in exploring the products offered by your website."
      className="whatsapp_float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FontAwesomeIcon icon={faWhatsapp} className="fa-whatsapp whatsapp-icon" />
    </a>
          <Footer></Footer>
        </Router>
   
    </div>
  );
}

export default App;
